(ns ycweb.app.website.myaccount.crop
  (:require [rum.core :as rum]
            [ycweb.util.core :as u]
            [ycweb.components.common :as cmn]))

;; TODO: there's a bug in maintaining aspect ratio - it can push it out of the image extents.
;; need to figure out how to clamp it, but also maintain aspect ratio.

(defn reset-orientation [base64 orientation callback]
  #?(:cljs
     (let [img (js/Image.)]
       (set! (.-onload img)
         (fn []
           (let [width (.-width img)
                 height (.-height img)
                 canvas (.createElement js/document "canvas")
                 ctx (.getContext canvas "2d")]
             (case
               (and (< 4 orientation) (< orientation 9))
               (do
                 (set! (.-width canvas) height)
                 (set! (.-height canvas) width))

               :else
               (do
                 (set! (.-width canvas) width)
                 (set! (.-height canvas) height)))

             (case orientation
               2 (.transform ctx 0 1 -1 0 height 0)
               3 (.transform ctx -1 0 0 -1 width height)
               4 (.transform ctx 0 -1 1 0 0 width)
               nil)

             ;; Original EXIF rotations, in case we need them.
             #_(case orientation
                 2 (.transform ctx -1 0 0 1 width 0)
                 3 (.transform ctx -1 0 0 -1 width height)
                 4 (.transform ctx 1 0 0 -1 0 height)
                 5 (.transform ctx 0 1 1 0 0 0)
                 6 (.transform ctx 0 1 -1 0 height 0)
                 7 (.transform ctx 0 -1 -1 0 height width)
                 8 (.transform ctx 0 -1 1 0 0 width)
                 nil)

             (.drawImage ctx img 0 0 width height)
             (callback (.toDataURL canvas) width height))))
       (set! (.-src img) base64))))

(defn write-cropped [nodes-atom callback]
  #?(:cljs
     (let [img-atom (rum/cursor-in nodes-atom [:rotated])
           crop-atom (rum/cursor-in nodes-atom [:crop])
           {:keys [p1 p2 targetsize imgsize]} @crop-atom
           [imgwidth imgheight] imgsize
           [targetwidth targetheight] targetsize
           img (js/Image.)]

       (set! (.-onload img)
         (fn []
           (let [canvas (.createElement js/document "canvas")
                 ctx (.getContext canvas "2d")
                 ;; Scale and extract the source cropping points
                 width-ratio (/ (.-width img) imgwidth)      ;; 600 source, 300 new = * 2
                 height-ratio (/ (.-height img) imgheight)

                 [p1x p1y] p1
                 [p2x p2y] p2
                 [p1x p2x] (map #(* width-ratio %) [p1x p2x])
                 [p1y p2y] (map #(* height-ratio %) [p1y p2y])

                 swidth (- p2x p1x)
                 sheight (- p2y p1y)]

             (set! (.-width canvas) targetwidth)
             (set! (.-height canvas) targetheight)

             (.drawImage ctx img p1x p1y swidth sheight 0 0 targetwidth targetheight)
             (callback (.toDataURL canvas)))))
       (set! (.-src img) @img-atom))))

(defn maintain-ratio [width-ratio [hx hy] [p1x p1y :as p1] [p2x p2y :as p2]]
  (let [width (Math/abs (- p2x p1x))
        height (Math/abs (- p2y p1y))
        current-ratio (/ width height)
        adjustment (/ width-ratio current-ratio)

        ;;100/200 = 0.5
        ;;
        ;;(/ 1 0.5) = 2
        ;;width * 2 = 200/ 200 =1

        ;;200/100 = 2
        ;;(/1 2) = 0.5
        ;;height / 0.5 = 200/200

        [newwidth newheight]
        (if (zero? hx)
          ;; Apply to width
          [(* width adjustment) height]
          ;; Apply to height
          [width (/ height adjustment)])

        ;; Pick 2
        [np1x np1y np2x np2y]
        [(- p2x newwidth) (- p2y newheight)
         (+ p1x newwidth) (+ p1y newheight)]]

    ;; Apply ratio adjustment according to handle
    (case [hx hy]
      [-1 -1] [[np1x np1y] p2]
      [-1 0] [[np1x p1y] [p2x np2y]]
      [-1 1] [[np1x p1y] [p2x np2y]]

      [0 -1] [p1 [np2x np2y]]
      [0 0] [p1 [np2x np2y]]
      [0 1] [[p1x np1y] [np2x p2y]]

      [1 -1] [[p1x np1y] [np2x p2y]]
      [1 0] [p1 [np2x np2y]]
      [1 1] [p1 [np2x np2y]]
      )))

(defn move-constraint [{:keys [mouse handle p1 p2 imgsize] :as c} [x y :as pos]]
  (let [[mx my] mouse
        diffx (- x mx)
        diffy (- y my)

        [hx hy] handle

        [p1x p1y] p1
        [p2x p2y] p2

        np1x (if (= hx -1) (+ p1x diffx) p1x)
        np2x (if (= hx 1) (+ p2x diffx) p2x)

        np1y (if (= hy -1) (+ p1y diffy) p1y)
        np2y (if (= hy 1) (+ p2y diffy) p2y)

        [imgwidth imgheight] imgsize

        [np1 np2]
        (maintain-ratio 1
          handle
          [(max (min np1x np2x) 0) (max (min np1y np2y) 0)]
          [(min (max np1x np2x) imgwidth) (min (max np1y np2y) imgheight)])]

    (assoc c :mouse pos
      :p1 np1
      :p2 np2
      :handle
      [(cond (zero? hx) 0 (> np1x np2x) (- hx) :else hx)
       (cond (zero? hy) 0 (> np1y np2y) (- hy) :else hy)])))

(defn move-selection [{:keys [mouse p1 p2 imgsize] :as c} [x y :as pos]]
  (let [[imgwidth imgheight] imgsize
        clamp-move-dims
        (fn [d md d1 d2 extent]
          (let [diff (- d md)
                diff
                (+ diff
                  (Math/abs (min 0 (+ d1 diff)))
                  (- extent (max extent (+ d2 diff))))]
            [(+ d1 diff) (+ d2 diff)]))

        [mx my] mouse
        [p1x p1y] p1
        [p2x p2y] p2

        [np1x np2x] (clamp-move-dims x mx p1x p2x imgwidth)
        [np1y np2y] (clamp-move-dims y my p1y p2y imgheight)]

    (assoc c :mouse pos
      :p1 [np1x np1y]
      :p2 [np2x np2y])))

(rum/defc crop-handles < rum/reactive [crop-atom img-atom imgsize mouse-down touch-down]
  (let [[p1x p1y] (cmn/curact crop-atom [:p1])
        [p2x p2y] (cmn/curact crop-atom [:p2])
        [imgwidth imgheight] imgsize

        width (Math/abs (- p1x p2x))
        height (Math/abs (- p1y p2y))
        x (min p1x p2x)
        y (min p1y p2y)]

    [:div
     {:style {:position "absolute",
              :z-index "600",
              :width (str width "px"),
              :height (str height "px"),
              :top (str y "px"),
              :left (str x "px"),
              :display "block"}}
     [:div
      {:style {:width "100%",
               :height "100%",
               :z-index "310",
               :position "absolute",
               :overflow "hidden"}}
      [:img
       {:src (rum/react img-atom),
        :on-mouse-down #(mouse-down % nil)
        :on-touch-start #(touch-down % nil)
        :style {:top (str (- y) "px"),
                :width (str imgwidth "px"),
                :max-width "290px",
                :padding "0px",
                :position "absolute",
                :border "none",
                :visibility "visible",
                :left (str (- x) "px"),
                :margin "0px"
                :cursor "move"}}]
      [:div
       {:style
        {:position "absolute", :opacity "0.4" :height "1px" :width "100%" :background "#FFF url(/img/crop-anim.gif) top left repeat"}}]
      [:div
       {:style {:position "absolute", :opacity "0.4" :height "1px" :width "100%" :background "#FFF url(/img/crop-anim.gif) top left repeat" :bottom 0}}]
      [:div
       {:style {:position "absolute", :opacity "0.4" :width "1px" :height "100%" :background "#FFF url(/img/crop-anim.gif) top left repeat" :right 0}}]
      [:div
       {:style {:position "absolute", :opacity "0.4" :width "1px" :height "100%" :background "#FFF url(/img/crop-anim.gif) top left repeat"}}]
      [:div
       {:style {:cursor "move", :position "absolute", :z-index "360"}}]]
     (into
       [:div
        {:style {:width "100%", :height "100%", :z-index "320", :display "block"}}]

       (->>
         (for [x (range -1 2) y (range -1 2)
               :when (not (and (zero? x) (zero? y)))]
           (let [direction
                 (str
                   (get {-1 "n" 1 "s"} y "")
                   (get {-1 "w" 1 "e"} x ""))
                 mouse-action
                 #(mouse-down % [x y])
                 touch-action
                 #(touch-down % [x y])]
             [(when (or (zero? x) (zero? y))
                [:div
                 {:on-mouse-down mouse-action
                  :on-touch-start mouse-action
                  :style
                  (u/maybe assoc
                    {:cursor (str direction "-resize"), :position "absolute", :z-index "370"
                     :height (if (zero? x) "7px" "100%") :width (if (zero? y) "7px" "100%")}
                    :margin-top (get {-1 "-4px"} y)
                    :top (get {-1 0} y)
                    :margin-bottom (get {1 "-4px"} y)
                    :bottom (get {1 0} y)
                    :margin-left (get {-1 "-4px"} x)
                    :left (get {-1 0} x)
                    :margin-right (get {1 "-4px"} x)
                    :right (get {1 0} x))}])

              [:div
               {:on-mouse-down mouse-action
                :on-touch-start touch-action
                :style
                (u/maybe assoc
                  {:cursor (str direction "-resize")
                   :position "absolute"
                   :background-color "#333"
                   :border "1px #eee solid"
                   :z-index "374"
                   :opacity "0.5"
                   :width "7px"
                   :height "7px"}
                  :top (get {-1 0, 0 "50%"} y)
                  :margin-top (get {-1 "-4px", 0 "-4px"} y)
                  :bottom (get {1 0} y)
                  :margin-bottom (get {1 "-4px", 0 "-4px"} y)
                  :left (get {-1 0, 0 "50%"} x)
                  :margin-left (get {-1 "-4px", 0 "-4px"} x)
                  :right (get {1 0} x)
                  :margin-right (get {1 "-4px", 0 "-4px"} x))}]]))
         (mapcat identity)
         (remove nil?)))]))

(rum/defc crop-pic < rum/reactive [nodes-atom]
  (let [img-atom (rum/cursor-in nodes-atom [:rotated])
        crop-atom (rum/cursor-in nodes-atom [:crop])
        [imgwidth imgheight :as imgsize] (cmn/curact crop-atom [:imgsize])

        ;; TODO: Unify these handlers a bit, this is messy.
        mouse-move
        (fn [e]
          (.preventDefault e)
          (let [pos [(.-screenX e) (.-screenY e)]]
            (swap! crop-atom
              (fn [c]
                (cond
                  (:handle c) (move-constraint c pos)
                  (:mouse c) (move-selection c pos)
                  :else c)))))

        touch-move
        (fn [e]
          (let [touch (first (seq (.-changedTouches e)))
                pos [(.-screenX touch) (.-screenY touch)]]
            (swap! crop-atom
              (fn [c]
                (if (:mouse c)
                  (move-constraint c pos)
                  c)))))

        mouse-up
        (fn [e]
          (swap! crop-atom dissoc :mouse :handle))

        mouse-down
        (fn [e handle]
          #?(:cljs
             (do
               (.preventDefault e)
               (.addEventListener js/document "mouseup" mouse-up)
               (.addEventListener js/document "mousemove" mouse-move)
               (.addEventListener js/document "touchend" mouse-up)
               (.addEventListener js/document "touchmove" touch-move)))
          (swap! crop-atom assoc :mouse [(.-screenX e) (.-screenY e)] :handle handle))

        touch-down
        (fn [e handle]
          #?(:cljs
             (let [touch (first (seq (.-changedTouches e)))]
               (.preventDefault e)
               (.addEventListener js/document "mouseup" mouse-up)
               (.addEventListener js/document "mousemove" mouse-move)
               (.addEventListener js/document "touchend" mouse-up)
               (.addEventListener js/document "touchmove" touch-move)
               (swap! crop-atom assoc :mouse [(.-screenX touch) (.-screenY touch)] :handle handle))))]
    [:div
     {:style
      {:width (str imgwidth "px"), :max-width "290px",
       :position "relative", :background-color "black"}}
     (crop-handles crop-atom img-atom imgsize mouse-down touch-down)
     [:div
      {:style {:width (str imgwidth "px"),
               :height (str imgheight "px"),
               :position "absolute",
               :top "-2px",
               :left "-2px",
               :z-index "290",
               :cursor "crosshair"}}]
     [:img
      {:src (rum/react img-atom),
       :style {:width "100%",
               :opacity "0.6",
               :padding "0px",
               :display "block",
               :border "none",
               :visibility "visible",
               :margin "0px"}}]]))


